'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import type { FilterOption } from '../../constants';
import { FilterCheckboxList } from '../FilterCheckboxList';
import { FilterChipGroup } from '../FilterChipGroup';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSection } from '../FilterSection';
import { FilterSidebarShell } from '../FilterSidebarShell';
interface GiftFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  categoryIds: number[];
  institutionIds: number[];
  onToggleCategory: (id: number) => void;
  onToggleInstitution: (id: number) => void;
  onReset: () => void;
}
export function GiftFilter(t0) {
  const $ = _c(42);
  const {
    isDrawerOpen,
    onCloseDrawer,
    onApplyDrawer,
    categoryIds,
    institutionIds,
    onToggleCategory,
    onToggleInstitution,
    onReset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home/gift-category/primary"](),
      staleTime: Infinity,
      gcTime: Infinity,
      select: _temp3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: t2,
    isLoading: isCategoryLoading
  } = useQuery(t1);
  let t3;
  if ($[1] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const categoryOptions = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home/institution/for-search-filter"]({
        query: {
          institutionFilterType: "PRODUCT"
        }
      }),
      staleTime: Infinity,
      gcTime: Infinity,
      select: _temp6
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    data: t5,
    isLoading: isInstitutionLoading
  } = useQuery(t4);
  let t6;
  if ($[4] !== t5) {
    t6 = t5 === undefined ? [] : t5;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const institutionOptions = t6;
  let t7;
  if ($[6] !== categoryIds || $[7] !== categoryOptions || $[8] !== isCategoryLoading || $[9] !== onToggleCategory) {
    t7 = <FilterSection title={"\uCE74\uD14C\uACE0\uB9AC"}><FilterCheckboxList options={categoryOptions} selectedValues={categoryIds} onToggle={onToggleCategory} isLoading={isCategoryLoading} skeletonCount={6} /></FilterSection>;
    $[6] = categoryIds;
    $[7] = categoryOptions;
    $[8] = isCategoryLoading;
    $[9] = onToggleCategory;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== institutionIds || $[12] !== institutionOptions || $[13] !== isInstitutionLoading || $[14] !== onToggleInstitution) {
    t8 = <FilterSection title={"\uC9C0\uC790\uCCB4"}><FilterCheckboxList options={institutionOptions} selectedValues={institutionIds} onToggle={onToggleInstitution} isLoading={isInstitutionLoading} skeletonCount={11} /></FilterSection>;
    $[11] = institutionIds;
    $[12] = institutionOptions;
    $[13] = isInstitutionLoading;
    $[14] = onToggleInstitution;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onReset || $[17] !== t7 || $[18] !== t8) {
    t9 = <FilterSidebarShell onReset={onReset}>{t7}{t8}</FilterSidebarShell>;
    $[16] = onReset;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h3 className="font-700 text-Gray-900 typo-body4">카테고리</h3>;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== categoryIds || $[22] !== categoryOptions || $[23] !== isCategoryLoading || $[24] !== onToggleCategory) {
    t11 = <div className="flex flex-col gap-12">{t10}<FilterChipGroup options={categoryOptions} selectedValues={categoryIds} onToggle={onToggleCategory} isLoading={isCategoryLoading} skeletonCount={6} /></div>;
    $[21] = categoryIds;
    $[22] = categoryOptions;
    $[23] = isCategoryLoading;
    $[24] = onToggleCategory;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h3 className="font-700 text-Gray-900 typo-body4">지자체</h3>;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== institutionIds || $[28] !== institutionOptions || $[29] !== isInstitutionLoading || $[30] !== onToggleInstitution) {
    t13 = <div className="flex flex-col gap-12">{t12}<FilterChipGroup options={institutionOptions} selectedValues={institutionIds} onToggle={onToggleInstitution} isLoading={isInstitutionLoading} skeletonCount={11} /></div>;
    $[27] = institutionIds;
    $[28] = institutionOptions;
    $[29] = isInstitutionLoading;
    $[30] = onToggleInstitution;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== isDrawerOpen || $[33] !== onApplyDrawer || $[34] !== onCloseDrawer || $[35] !== onReset || $[36] !== t11 || $[37] !== t13) {
    t14 = <FilterDrawerShell isOpen={isDrawerOpen} onReset={onReset} onApply={onApplyDrawer} onClose={onCloseDrawer}>{t11}{t13}</FilterDrawerShell>;
    $[32] = isDrawerOpen;
    $[33] = onApplyDrawer;
    $[34] = onCloseDrawer;
    $[35] = onReset;
    $[36] = t11;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== t14 || $[40] !== t9) {
    t15 = <>{t9}{t14}</>;
    $[39] = t14;
    $[40] = t9;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
}
function _temp6(t0) {
  const {
    context: context_0
  } = t0;
  return (context_0?.contents ?? []).filter(_temp4).map(_temp5);
}
function _temp5(item_2) {
  return {
    value: item_2.institutionId,
    label: item_2.institutionName
  };
}
function _temp4(item_1) {
  return Boolean(item_1.institutionName);
}
function _temp3(t0) {
  const {
    context
  } = t0;
  return (context?.contents ?? []).filter(_temp).map(_temp2);
}
function _temp2(item_0) {
  return {
    value: item_0.giftCategoryId,
    label: item_0.categoryName
  };
}
function _temp(item) {
  return Boolean(item.categoryName);
}